import { TextField, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#198754',
        },
        '&:hover fieldset': {
            borderColor: '#198754',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#198754',
        },
    },
    '& .MuiInputLabel-root': {
        color: '#198754',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#198754',
    },
});

export const CustomSelect = styled(Select)({
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#198754',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#198754',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#198754',
    },
    '& .MuiSelect-icon': {
        color: '#198754',
    },
});

export const HomeCustomTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#FF8800',
        },
        '&:hover fieldset': {
            borderColor: '#FF8800',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#FF8800',
        },
    },
    '& .MuiInputLabel-root': {
        color: '#FF8800',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#FF8800',
    },
});

export const HomeCustomSelect = styled(Select)({
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#FF8800',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#FF8800',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#FF8800',
    },
    '& .MuiSelect-icon': {
        color: '#FF8800',
    },
    '& .MuiFormLabel-root ': {
        color: '#FF8800', // Default label color
    },
    '& .MuiInputLabel-root': {
        color: '#FF8800', // Default label color
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#FF8800', // Focused label color
    },
    '& .MuiInputLabel-root.Mui-error': {
        color: '#FF0000', // Error label color if needed
    },
});
export const HomeCustomGreenSelect = styled(Select)({
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#198754',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#198754',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#198754',
    },
    '& .MuiSelect-icon': {
        color: '#198754',
    },
    '& .MuiFormLabel-root ': {
        color: '#198754', // Default label color
    },
    '& .MuiInputLabel-root': {
        color: '#198754', // Default label color
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#198754', // Focused label color
    },
    '& .MuiInputLabel-root.Mui-error': {
        color: '#198754', // Error label color if needed
    },
});